"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _messagePopup = _interopRequireDefault(require("../message-popup/message-popup"));

var _buttonTypes = _interopRequireDefault(require("../message-popup/button-types"));

var _formInput = _interopRequireDefault(require("../form-input/form-input"));

var _supportErrorPopup = _interopRequireDefault(require("./support-error-popup/support-error-popup"));

var _supportCompletePopup = _interopRequireDefault(require("./support-complete-popup/support-complete-popup"));

const MIN_LETTERS = 30;

class SupportPopup extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      value: '',
      isMessageSent: false,
      showMinLettersError: false,
      showErrorPopup: false,
      isSending: false
    });
    (0, _defineProperty2.default)(this, "onValueChange", value => {
      const {
        showMinLettersError
      } = this.state;

      if (value.length >= MIN_LETTERS && showMinLettersError) {
        this.setState({
          showMinLettersError: false
        });
      }

      this.setState({
        value
      });
    });
    (0, _defineProperty2.default)(this, "onSendMessage", async () => {
      const {
        value
      } = this.state;

      if (value.length < MIN_LETTERS) {
        this.setState({
          showMinLettersError: true
        });
        return;
      }

      const {
        onSendMessage
      } = this.props;
      this.setState({
        isSending: true
      });
      const success = await onSendMessage(value);
      this.setState({
        isSending: false
      });

      if (success) {
        this.setState({
          isMessageSent: true
        });
      } else {
        this.setState({
          showErrorPopup: true
        });
      }
    });
    (0, _defineProperty2.default)(this, "onSupportErrorPopupClose", () => {
      this.setState({
        showErrorPopup: false
      });
    });
  }

  render() {
    const {
      onCancel,
      onClose
    } = this.props;
    const {
      value,
      showMinLettersError,
      isMessageSent,
      showErrorPopup,
      isSending
    } = this.state;

    if (showErrorPopup) {
      return /*#__PURE__*/_react.default.createElement(_supportErrorPopup.default, {
        onClose: this.onSupportErrorPopupClose
      });
    }

    if (isMessageSent) {
      return /*#__PURE__*/_react.default.createElement(_supportCompletePopup.default, {
        onClose: onClose
      });
    }

    return /*#__PURE__*/_react.default.createElement(_messagePopup.default, {
      className: "support-popup",
      title: "Get Support",
      onClose: onClose,
      buttons: [{
        value: 'cancel',
        name: 'Cancel',
        onClick: onCancel,
        type: _buttonTypes.default.WHITE
      }, {
        value: 'send-message',
        name: 'Send message',
        onClick: this.onSendMessage,
        disabled: value.length < MIN_LETTERS,
        isLoading: isSending
      }]
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "support-popup__title"
    }, "What do you need help with?"), /*#__PURE__*/_react.default.createElement(_formInput.default, {
      value: value,
      onChange: this.onValueChange,
      multiLine: true,
      showLetterLimit: true,
      minRows: 4,
      maxLength: 500
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('support-popup__min-letters', {
        'support-popup__min-letters--error': showMinLettersError
      })
    }, "Minimum 30 characters"));
  }

}

(0, _defineProperty2.default)(SupportPopup, "propTypes", {
  onCancel: _propTypes.default.func.isRequired,
  onSendMessage: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func.isRequired
});
var _default = SupportPopup;
exports.default = _default;